//

import { useEffect, useState } from 'react';
import DynamicJobCreationForm from '../formData';
import useApi from 'hooks/useApi';
import { useParams } from 'react-router-dom';
import { Box, CircularProgress, Typography, Button } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import MainCard from 'components/MainCard';

const AddTransactionPage = () => {
  const { teamUid } = useParams();
  const navigate = useNavigate();
  const [transactionDetails, setTransactionDetails] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const { addNewStepFlow } = useApi();

  useEffect(() => {
    if (!teamUid) return;
    const fetchData = async () => {
      setLoading(true);
      const resp = await addNewStepFlow(teamUid);
      if (resp?.success) {
        setTransactionDetails(resp.data);
      }
      setLoading(false);
    };
    fetchData();
  }, [teamUid, ]);

  
  return (
    <>
      {loading ? (
        <Box
          sx={{
            p: 4,
            textAlign: 'center',
            borderRadius: 1,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 2
          }}
        >
          <CircularProgress size={40} />
          <Typography
            variant="body2"
            sx={{
              color: 'text.secondary',
              fontSize: 14
            }}
          >
            Loading transaction form...
          </Typography>
        </Box>
      ) : transactionDetails?.step?.component?.fields?.length > 0 ? (
        <DynamicJobCreationForm 
          transactionDetails={transactionDetails.step} 
          FullTransaction={transactionDetails} 
          setTransactionDetails={setTransactionDetails}
        />
      ) : (
        <MainCard
          content={false}
          sx={{
            flex: 1,
            borderRadius: 2,
            boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden'
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              minHeight: '30vh',
              textAlign: 'center',
              p: 4
            }}
          >
            <Typography variant="h4" color="error" gutterBottom>
              No Workflow Available
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ mb: 3, maxWidth: 600 }}>
              You don't have any workflow configured for this process. Please contact your administrator to set up the workflow before creating transactions.
            </Typography>
            <Button
              variant="contained"
              startIcon={<ArrowBack />}
              onClick={() => navigate('/transactions')}
              sx={{ mt: 2 }}
            >
              Back to Transactions
            </Button>
          </Box>
        </MainCard>
      )}
    </>
  );
};

export default AddTransactionPage;
